import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const FEATURE_KEY = 'persistSystem';

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface PersistSystemState {
  endpointLastCalled: {
    [key: string]: number;
  };
}

const initialState: PersistSystemState = {
  endpointLastCalled: {},
};

export const PersistSystemSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {
    setLastCalled: (state, action: PayloadAction<string>) => {
      state.endpointLastCalled[action.payload] = new Date().getTime();
    },
    clearLastCalled: (state, action: PayloadAction<string>) => {
      delete state.endpointLastCalled[action.payload];
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = PersistSystemSlice.reducer;
const actions = PersistSystemSlice.actions;

const state = (rootState: any): PersistSystemState => rootState[FEATURE_KEY];

const endpointLastCalledSelector = (key: string) => (state: any) => {
  const persistSystemState = state[FEATURE_KEY] as PersistSystemState;

  return persistSystemState.endpointLastCalled[key];
};

const endpointLastCalledWithinMillisecondsSelector =
  (key: string, milliseconds: number) => (state: any) => {
    const persistSystemState = state[FEATURE_KEY] as PersistSystemState;

    if (persistSystemState.endpointLastCalled[key]) {
      return (
        new Date().getTime() <
        persistSystemState.endpointLastCalled[key] + milliseconds
      );
    } else {
      return false;
    }
  };

export {
  actions,
  reducer,
  endpointLastCalledSelector,
  endpointLastCalledWithinMillisecondsSelector,
};
